<script>
  import { onMount } from 'svelte';
  import { userid, isProduction } from './utils';
  import LED from './components/LED.svelte';
  import Notification from './components/notification/Index.svelte';
  export let user = '{"test":"true"}';
  export let production = false;
  let mounted = false;

  onMount(() => {
    const parsedUser = JSON.parse(user);
    if (parsedUser) {
      $userid = parsedUser.access_token;
      $isProduction = production;
    }
    mounted = true;
  });
</script>

{#if mounted}
  <main>
    <Notification />
    <LED />
  </main>
{/if}

<style>:global(*){box-sizing:border-box;margin:0}:global(html,body){font-family:Overpass,sans-serif;height:100%;margin:0;padding:0;width:100%}main{position:relative;width:100%}:global(:is(h1,h2)){font-family:Chivo,sans-serif}:global(:is(h1)){font-weight:900}:global(header){align-items:center;border-bottom:1px solid #dadada;display:flex;justify-content:space-between;margin-bottom:1em;padding:1em 0}</style>
